export default __webpack_public_path__ + "static/media/search-chevron-icon.c556a020.svg";